import { Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ParentCellOrFragment from './ParentCellOrFragment'

// The single, shared empty-value placeholder for the new MRT tables. Columns render this from their
// registry when a cell has no value, so every empty cell looks the same ("Empty", muted) without the
// individual value cells needing to know about it.
const EmptyCell: React.FC<{ disableCell?: boolean }> = ({ disableCell }) => {
  const { formatMessage } = useIntl()

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <Typography color="action.disabled">{formatMessage({ id: 'general.empty' })}</Typography>
    </ParentCellOrFragment>
  )
}

export default EmptyCell
